import fr from './fr.json'
import en from './en.json'
import es from './es.json'
import nl from './nl.json'
import pt from './pt.json'

export default {
    fr,
    en, 
    es, 
    nl, 
    pt
  }